import styles from './IconLink.module.scss'
import Link from 'next/link'
import React from 'react'

type Props = {
  label: string,
  icon?: React.FunctionComponent<any>,
  href: string,
}

const IconLink = (props: Props) => {
  const IconComponent = props.icon as React.ElementType

  return (
    <div className={styles.component}>
      {props.icon && (
        <IconComponent className={styles.icon} />
      )}
      <Link href={props.href}>{props.label}</Link>
    </div>
  )
}

export default IconLink